var _path, _path2, _path3, _path4, _g, _circle, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBruisedBananaMag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 107,
    viewBox: "0 0 84 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.951 83.8477C20.796 71.849 23.2206 55.669 25.739 48.9747C28.2574 42.2803 33.5954 31.2883 39.5378 28.2831C44.5637 25.7413 48.8431 26.816 47.7467 32.9477C46.6502 39.0794 47.4954 31.1324 43.7835 52.3219C40.0716 73.5114 54.8735 86.7181 66.3437 90.9057C77.8138 95.0933 74.1401 104.316 64.2919 105.375C47.8783 107.139 35.1578 97.6109 26.951 83.8477Z",
    fill: "#FFEFCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2613 71.6254C17.1356 70.6821 3.77012 71.6254 0 82.002C10.6035 78.8203 17.6838 76.8137 24.2613 82.002C30.8389 87.1902 30.2908 90.0202 36.3202 96.1518C42.3497 102.283 51.1197 106.057 60.9861 107C68.6599 107 73.045 105.585 74.1412 102.283C75.2375 98.9818 74.6894 98.0385 73.045 95.2085C71.4006 92.3785 53.3123 82.002 53.3123 82.002C57.1492 70.6821 67.2624 67.4182 76.5807 69.7765C85.8989 72.1348 74.1412 62.2754 65.5059 62.2754C58.2013 62.86 53.9599 64.0792 50.5716 66.4371C44.5914 70.5988 43.4459 76.342 43.4459 82.002C40.7053 77.2853 31.387 72.5687 24.2613 71.6254Z",
    fill: "#FFDB59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 59C42.6 56.2 44 51 44 49.5C42.5 44 40.1667 46.5 39 48.5C38 49.6667 36.2 52.9 37 56.5C38 61 43 61 43 59Z",
    fill: "#A2614D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 76C59 72 63.4999 69.9999 65.4999 69.5737C69.5 63.4999 63.5 64.2645 61 64.5C59.4702 64.6441 55.6965 66.4291 53.7701 69.5738C51.3622 73.5047 55.1102 77.4382 56.5 76Z",
    fill: "#A2614D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_1234)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_306_1234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7251 115.962C-2.97017 85.3649 3.21256 44.106 9.63448 27.0355C16.0564 9.96477 29.6683 -18.0649 44.8214 -25.7282C57.6375 -32.2096 68.5499 -29.4692 65.7541 -13.8333C62.958 1.80247 65.1133 -18.4625 55.6479 35.5708C46.1826 89.6041 83.9274 123.281 113.176 133.96C142.425 144.638 133.057 168.156 107.944 170.855C66.0897 175.355 33.6524 151.058 12.7251 115.962Z",
    fill: "#FFEFCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86631 84.7948C-12.3042 82.3894 -46.3862 84.7948 -56 111.255C-28.9611 103.142 -10.9063 98.0249 5.86631 111.255C22.6392 124.485 21.2415 131.702 36.6165 147.337C51.9917 162.973 74.3552 172.595 99.5146 175C119.083 175 130.265 171.392 133.06 162.973C135.856 154.554 134.458 152.148 130.265 144.932C126.072 137.715 79.9464 111.255 79.9464 111.255C89.7305 82.3894 115.519 74.0664 139.281 80.0801C163.042 86.0937 133.06 60.9523 111.04 60.9523C92.4133 62.443 81.5977 65.552 72.9576 71.5646C57.7081 82.1769 54.787 96.8221 54.787 111.255C47.7985 99.2275 24.0368 87.2002 5.86631 84.7948Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65 52.6C52.63 45.46 56.2 32.2 56.2 28.375C52.375 14.35 46.4251 20.725 43.45 25.825C40.9 28.8001 36.31 37.045 38.35 46.225C40.9 57.7 53.65 57.7 53.65 52.6Z",
    fill: "#A2614D"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 32.5,
    r: 31.5,
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 63.4142,
    y1: 54,
    x2: 83,
    y2: 73.5858,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_1234"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_306_1234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 204,
    fill: "white",
    transform: "translate(-56 -29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBruisedBananaMag);
export default __webpack_public_path__ + "static/media/bruisedBanana_mag.6a95bfb8883ac2d91ddb434bf2e1038f.svg";
export { ForwardRef as ReactComponent };